import { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import Modal from "../modal";
import { ErrorContext } from "../../utils/context/error";
import { getPermisoInt, actualizaPermiso } from "../../services/permission";

function PermissionModal({ show, MenuI, ItemI, Tag, handleshow, fillPermisos }) {
  const [programa, setPrograma] = useState([]);
  const [habilita, setHabilita] = useState(false);
  const [ItemId, setItemId] = useState(0);
  const [MenuId, setMenuId] = useState(0);
  const [nombreItem, setNombreItem] = useState("");
  const [codigoItem, setCodigoItem] = useState("");
  const { setShowToast, setOpciones } = ErrorContext();
  const [Titulo, setTitulo] = useState("");
  const [validar, setValidar] = useState(false);

  const handleCancel = async () => 
    {
      handleshow(false);
    };
  
  //-----------------------------------------------------
  const handleAceptar = async () => 
    {
      setHabilita(true);
      setShowToast(false);
      const response = await actualizaPermiso(
        {
           MenuId,
           ItemId,
           nombreItem,
           codigoItem,
           Tag,
        });
      
      if (response) 
        {
          if (response.status === 200) 
            {
              fillPermisos();
              handleshow(false);
            } 
          else 
           {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
           }
        }
      setHabilita(false);
    };

    //-------------------------------------------------------
    const fillPermisoInt = async (MenuI, ItemI) => 
      {
         setShowToast(false);
         const response = await getPermisoInt(MenuI, ItemI);
         if (response) 
          {
             if (response.status === 200) 
              {
                if (Tag!==0)
                {
                   setNombreItem(response.data.data[0].NombreItem);
                   setCodigoItem(response.data.data[0].CodigoItem);
                   setMenuId(response.data.data[0].MenuId);
                   setItemId(response.data.data[0].ItemId);
                }   
                setPrograma(response.data.menu);
              } 
             else 
             {
                const Mensaje = response.message;
                const opc = { type: "Danger", message: Mensaje, active: true };
                setOpciones(opc);
                setShowToast(true);
             }
          }
      };
   
    //----------------------------------------------------
    useEffect(() => 
      {
        if (show) 
          {
            setNombreItem("");
            setCodigoItem("");
            setMenuId(MenuI);
            setItemId(ItemI);
            fillPermisoInt(MenuI,ItemI);
     
            if (Tag !== 0) 
              {
                 if (Tag === 1) setTitulo("Editar Permiso (" + MenuI+","+ItemI + ")");
                 if (Tag === 2) setTitulo("Eliminar Permiso (" + MenuI+","+ItemI + ")");
              } 
            else 
             {
               setItemId(0);
               setMenuId(0);
               setTitulo("Nueva Permiso");
             }
          }
      }, [show]);

  return (
    <>

    <Modal isOpen={show} onClose={()=>handleshow(false)} title={Titulo}>
            <div className="flex lg:w-[26rem]">
                <form noValidate className="flex flex-col w-full">
                    <div className="flex flex-col w-full h-full ">
                       <div className="w-full">
                           <label>Programa</label>
                               <select id="programa" name="programa" value={MenuId || 0} 
                                  onChange={(e) => setMenuId(e.target.value)} 
                                  label="Programa" disabled={Tag === 2 || Tag === 1}
                                  className={`${validar && MenuId === 0 ? `validar`: ""}`}
                               >
                                  <option value={0} disabled>
                                     Seleccionar Programa...
                                  </option>
                                  {programa.map((item) => 
                                    {
                                     return (
                                         <option key={item.MenuId} value={item.MenuId}>
                                             {item.NombreMenu}
                                         </option>
                                       );
                                    })}
                               </select>
                            {validar && MenuId === 0 && (
                               <p className={`text-red-500 text-[0.6rem] font-medium italic`}>
                                     * Campo Obligatorio.
                               </p>
                            )}
                       </div>
                       <div className="w-full mt-4">
                           <label>Código Permiso</label>
                           <input type="text" name='searchid' value={codigoItem || ""} placeholder="Ingresa el Código" 
                            onChange={(e)=> setCodigoItem(e.target.value.toUpperCase())}
                            autoComplete="off" 
                            className={`${validar && codigoItem === "" ? `validar`: ""}`}
                            disabled={(Tag === 2) || (Tag === 1)}>
                          </input>
                          {validar && codigoItem === "" && (
                               <p className={`text-red-500 text-[0.6rem] font-medium italic`}>
                                     * Campo Obligatorio.
                               </p>
                            )}
                       </div>
                       <div className="w-full mt-4">
                           <label>Nombre Permiso</label>
                           <input type="text" name='searchid' value={nombreItem || ""} placeholder="Ingresa el nombre" 
                            onChange={(e)=> setNombreItem(e.target.value)}
                            autoComplete="off" 
                            className={`${validar && nombreItem === "" ? `validar`: ""}`}
                            disabled={(Tag === 2)}>
                          </input>
                          {validar && nombreItem === "" && (
                               <p className={`text-red-500 text-[0.6rem] font-medium italic`}>
                                     * Campo Obligatorio.
                               </p>
                            )}
                       </div>
                     <div className="flex w-full gap-4 mt-6 justify-end">
                          <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                          <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
                     </div>  
                 </div>
              </form>
           </div>
        </Modal>          
    </>
  );
}
PermissionModal.propTypes = {
  show: PropTypes.bool.isRequired,
  MenuI: PropTypes.number.isRequired, 
  ItemI: PropTypes.number.isRequired,
  Tag: PropTypes.number.isRequired,
  handleshow: PropTypes.func.isRequired,
  fillPermisos: PropTypes.func.isRequired,
};

export default PermissionModal;
